import { defineStore } from 'pinia'
import { io } from 'socket.io-client'
import useAuthStore from './auth'
import { useToast } from 'vue-toastification'

const useStatusStore = defineStore('socket', () => {
	const socket = ref(null)
	const users = ref([])
	const lockedPriceBoxes = ref([])
	const isRegistered = ref(false)
	const socketInstanceId = ref(null)

	const toast = useToast()

	const authStore = useAuthStore()

	const runtimeConfig = useRuntimeConfig()

	const setUser = () => {
		const token = authStore.token

		socket.value.emit('setUser', token)
	}

	const disconnect = () => {
		socket.value.disconnect()

		isRegistered.value = false
	}

	const lockPriceBox = (priceBoxId) => {
		socket.value.emit('lockPriceBox', priceBoxId)
	}

	const releasePriceBox = (priceBoxId) => {
		socket.value.emit('releasePriceBox', priceBoxId)
	}

	const initialize = () => {
		socket.value = io(
			`${runtimeConfig.public.wsDomain}${runtimeConfig.public.wsNamespace}`,
			{
				path: runtimeConfig.public.wsPath,
				autoConnect: true,
				transports: ['websocket']
			}
		)

		socket.value.on('lockedPriceBoxes', (payload) => {
			lockedPriceBoxes.value = payload.map((priceBox) => ({
				id: priceBox.priceBox.id,
				userId: priceBox.user.id,
				...priceBox
			}))
		})

		socket.value.on('activeUsers', (activeUsers) => {
			users.value = activeUsers
		})

		socket.value.on('priceBoxLocked', (priceBox, user, lockedAt) => {
			lockedPriceBoxes.value.push({
				id: priceBox.id,
				userId: user.id,
				priceBox,
				user,
				lockedAt
			})
		})

		socket.value.on('priceBoxReleased', (priceBoxId) => {
			lockedPriceBoxes.value = lockedPriceBoxes.value.filter(
				(priceBox) => +priceBox.id !== +priceBoxId
			)
		})

		socket.value.on('userLogin', (user) => {
			if (users.value.some((u) => u.id === user.id)) {
				return
			}

			users.value.push(user)
		})

		socket.value.on('userLogout', (user) => {
			users.value = users.value.filter((u) => u.id !== user.id)
		})

		socket.value.on('instanceRegistered', (instanceId) => {
			isRegistered.value = true

			socketInstanceId.value = instanceId
		})

		socket.value.on('connect', () => {
			setUser()
		})

		socket.value.on('connect_error', (error) => {
			console.error('Connection Error:', error)
		})

		socket.value.on('priceBoxKick', async () => {
			await navigateTo({
				path: '/',
				force: true,
				query: {
					force_redirect: true
				}
			})

			toast.info('Boli ste presmerovaný na domovskú stránku')
		})
	}

	const getUserByLockedPriceBoxId = (priceBoxId) => {
		const priceBox = lockedPriceBoxes.value.find(
			(priceBox) => +priceBox.id === +priceBoxId
		)

		return priceBox.user
	}

	return {
		users,
		lockedPriceBoxes,
		initialize,
		setUser,
		lockPriceBox,
		releasePriceBox,
		disconnect,
		isRegistered,
		getUserByLockedPriceBoxId,
		socketInstanceId
	}
})

export default useStatusStore
